import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import './style.scss';

const DialogComponent = (props) => {
  const {
    children, className, onClose, open,
  } = props;

  return (
    <Modal
      onClose={onClose}
      aria-labelledby='simple-dialog-title'
      open={open}
      className={`modal-container ${className}`}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className='paper-container'>
          {children}
        </div>
      </Fade>
    </Modal>
  );
};

DialogComponent.propTypes = {
  children: PropTypes.shape().isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

DialogComponent.defaultProps = {
  className: '',
  onClose: (fn) => fn,
  open: false,
};

export default DialogComponent;
